import {stepName as idVerification} from './steps/useIdVerificationStep'
import {stepName as acceptTerms} from './steps/useAcceptTermsStep'

export default ({kycVerified, kycStatus, acceptedTermsAndConditions}) => {
  if (!acceptedTermsAndConditions) {
    return acceptTerms
  }

  if (kycStatus !== 'verified' && !kycVerified) {
    return idVerification
  }

  return null
}
